import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CustomerTableDTO } from 'src/app/models/dtos/customerTableDTO';

@Component({
  selector: 'app-customer-photo-dialog',
  templateUrl: './customer-photo-dialog.component.html',
  styleUrls: ['./customer-photo-dialog.component.scss']
})
export class CustomerPhotoDialogComponent implements OnInit {

  customer: CustomerTableDTO;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) { }

  ngOnInit(): void {
    this.customer = this.config.data.customer;
  }

}